import A11yDialog from 'a11y-dialog';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.dialog-container').forEach((el) => {
    const dialog = new A11yDialog(el, document.getElementById('main'));

    // Add any event handlers here...
    // See https://github.com/edenspiekermann/a11y-dialog#js-api

    dialog.on('show', function (event) {
      const container = event.target;
      if (el.classList.contains('dialog-container--has-video')) {
        const thumbnail = el.querySelector('.video-placeholder__thumbnail');
        if (thumbnail) thumbnail.click();
        const video = el.querySelector('.video-placeholder__video');
        if (video) {
          if (video.classList.contains('video-placeholder__video--iframe')) {
            video.removeAttribute('srcdoc');
          } else {
            video.play();
          }
        }
      }
    });

    dialog.on('hide', function (event) {
      const container = event.target;
      if (el.classList.contains('dialog-container--has-video')) {
        const video = el.querySelector('.video-placeholder__video');
        if (video) {
          if (video.classList.contains('video-placeholder__video--iframe')) {
            video.srcdoc = '';
          } else {
            video.pause();
          }
        }
      }
    });
  });
});
